

import { useEffect, useState, useRef, useMemo } from "react";

import liff from "@line/liff";
import { CURRENT_ENV } from "../../Utills/constants";
import axios from "axios";
import LoadingScreen from "../Loading/LoadingScreen";
import { useSearchParams } from "react-router-dom";

function MainScreen() {
  const [profileLine, setProfileLine] = useState();
  const [data, setData] = useState(null);
  const [listRewards, setListRewards] = useState(null);
  const [rewards, setRewards] = useState(null);
  const [isShaking, setIsShaking] = useState(false);
  const [loading, setLoading] = useState(true);
  const canvasRef = useRef(null);
  const [imageSrc, setImageSrc] = useState("");

  const [searchParams] = useSearchParams();
  const decodedState = decodeURIComponent(searchParams);
  const params = useMemo(() => new URLSearchParams(decodedState), [decodedState]);

  const getCode = params.get("code");
  const getGame = params.get("g");
  // const getLiffId = params.get("id");

  console.log(getCode, getGame)
  useEffect(() => {

    liff
      .init({
        liffId: CURRENT_ENV.LIFF_ID,
      })
      .then(async () => {
        if (liff.isInClient()) {
          if (liff.isLoggedIn()) {

            liff
              .getProfile()
              .then((profile) => {
                console.log("%cPROFILE LINEOA : ", "color: green", profile);
                setProfileLine(profile);
              })
              .catch((err) => {
                console.log("%cERROR LINEOA DETAIL", "color: red", err);
              });
          } else {
            const setUrl = window.location.href;
            liff.login({ redirectUri: setUrl })
          }
        } else {
          window.alert(`ไม่สามารถใช้งานได้\nกรุณาใช้งานผ่าน LineOA เท่านั้น`)
        }
      })
      .catch((err) => {
        console.log(
          "%cERROR LINEOA HEADER",
          "color: red",
          err.code,
          err.message
        );
      });
    return () => { };
  }, [params]);

  useEffect(() => {
    const fetchData = async () => {

      if (profileLine) {

        try {
          const response = await axios.get(`${CURRENT_ENV.API_BASE_URL}?path=getData&userId=${profileLine.userId}&displayName=${profileLine?.displayName}&pictureUrl=${profileLine?.pictureUrl}&statusMessage=${profileLine?.statusMessage}&g=${getGame}&code=${getCode}`);
          if (response.data.status === 200) {
            setData(response.data.data)
          }
        } catch (_) { }
        finally {
        }
      }
    };
    fetchData();

  }, [profileLine, getGame]);

  useEffect(() => {
    const fetchRewards = async () => {
      if (profileLine) {
        try {
          const response = await axios.get(`${CURRENT_ENV.API_BASE_URL}?path=getRewards&g=${getGame}&code=${getCode}&userId=${profileLine.userId}&displayName=${profileLine?.displayName}&pictureUrl=${profileLine?.pictureUrl}&statusMessage=${profileLine?.statusMessage}`);
          if (response.data.status === 200) {
            setListRewards(response.data)

            const img = new Image();
            img.src = response.data.gameImage;
            img.crossOrigin = "anonymous";

            img.onload = () => {
              const canvas = canvasRef.current;
              const ctx = canvas.getContext("2d");
              canvas.width = img.width;
              canvas.height = img.height;
              ctx.drawImage(img, 0, 0);

              setImageSrc(canvas.toDataURL("image/png"));
            };
          }
        } catch (_) { }
        finally {
          setLoading(false)
        }
      }
    };
    fetchRewards();

  }, [profileLine, getGame]);

  const randomRewards = async () => {
    try {
      setIsShaking(true);
      setRewards(null)
      const response = await axios.get(`${CURRENT_ENV.API_BASE_URL}?path=play&userId=${profileLine.userId}&displayName=${profileLine?.displayName}&pictureUrl=${profileLine?.pictureUrl}&statusMessage=${profileLine?.statusMessage}&g=${getGame}&code=${getCode}`);
      if (response.data.status === 200) {
        setRewards(response.data)
        setData(response.data.data)
        liff
          .sendMessages([
            {
              "type": "flex",
              "altText": `ยินดีด้วยคุณได้รับรางวัล คลิกเพื่อดู`,
              "contents": {
                "type": "bubble",
                "hero": {
                  "type": "image",
                  "url": response.data.reward.imageFlex,
                  "size": "full",
                  "aspectRatio": "1:1",
                  "aspectMode": "cover"
                },
                "body": {
                  "type": "box",
                  "layout": "vertical",
                  "contents": [
                    {
                      "type": "text",
                      "text": listRewards.headerFlex,
                      "weight": "bold",
                      "size": "xl"
                    },
                    {
                      "type": "box",
                      "layout": "vertical",
                      "contents": [
                        {
                          "type": "text",
                          "text": `${listRewards.bodyFlex} ${response.data.reward.name}`,
                          "size": "lg",
                          "color": "#B3B3B3",
                          "wrap": true
                        }
                      ]
                    }
                  ]
                }
              }
            }
          ])
          .then(() => {
            window.alert("ส่งรางวัลไปยังช่องแชทเรียบร้อยค่ะ")
            if (response.data.data.value === 0) {
              liff.closeWindow()
            }
          })
          .catch((err) => {
            window.alert(err);
          });
      } else if (response.data.status === 204) {
        window.alert(response.data.message)
      }
    } catch (_) { }
    finally {
      setIsShaking(false)
    }
  };

  return (
    <>
      {
        loading ?
          <LoadingScreen />
          : null

      }
      <div>
        <div className="container app-bg" style={{ backgroundImage: listRewards?.backgroundGame ? `url(${listRewards?.backgroundGame})` : "none" }}>
          <div style={{ width: `90%` }}>
            {/* <div>
              <h1 className="txt-title">สุ่มกาชาปอง 199฿ ลุ้นรางวัลใหญ่</h1>
            </div> */}
            <div>
              {
                data?.value === 0 ?
                  // <img src={listRewards?.gameImage} alt="" className="reward-image" style={{ opacity: 0.5 }} />
                  <>
                    <canvas ref={canvasRef} style={{ display: "none" }} />
                    {imageSrc && <img src={imageSrc} style={{ width: `100%`, opacity: 0.5 }} alt="gif" />}
                  </>
                  :
                  // <img onClick={() => { randomRewards() }} src={listRewards?.gameImage} alt="" className={`reward-image ${isShaking ? "shake" : ""}`} />
                  <>
                    {
                      isShaking ?
                        <img src={listRewards?.gameImage} style={{ width: `100%` }} alt="" />
                        :
                        <>
                          <canvas ref={canvasRef} style={{ display: "none" }} />
                          {imageSrc && <img src={imageSrc} onClick={() => { randomRewards(); }} style={{ width: `100%` }} alt="gif" />}
                        </>
                    }

                  </>
              }
            </div>

            {
              data ?
                <div>
                  <div style={{ display: `flex`, flexDirection: `row`, backgroundColor: `#8d8d8d`, color: `white`, borderRadius: 20, justifyContent: `center`, alignContent: `center`, overflow: `scroll`, padding: 5, fontSize: 16, border: `2px solid rgb(255 255 255)` }}>
                    จำนวนครั้งที่สามารถเล่นได้ : {data?.value}
                  </div>
                </div>
                : null
            }



            {
              listRewards?.data ?
                <div style={{ marginTop: 20 }}>
                  <div className="txt-title" style={{ fontSize: 20, fontWeight: `bold` }}>ของรางวัล</div>
                  <div style={{ display: `flex`, justifyContent: `center`, padding: 10 }}>
                    <div style={{ display: `grid`, width: `100%` }}>
                      <div className="grid-container">
                        {
                          listRewards?.data?.map((data, index) => (
                            <div key={index} style={{ border: `2px solid white` }}>
                              <div style={{ display: `flex`, justifyContent: `center`, alignItems: `center`, flexDirection: `column`, margin: 2, fontSize: 12 }}>
                                <img src={data.image} alt="" style={{ width: 30 }} />
                                <div>
                                  {data.name}
                                </div>
                              </div>
                            </div>
                          ))
                        }
                      </div>
                    </div>
                  </div>
                </div> : null
            }
          </div>
        </div>
      </div>
    </>
  );
}

export default MainScreen;
